import React from 'react';
import { useNavigate } from 'react-router-dom';
import NewsCard from './NewsCard';
import { NewsArticle } from './types';

interface NewsSectionProps {
  articles: NewsArticle[];
  categoryName: string;
}

const NewsSection: React.FC<NewsSectionProps> = ({ articles, categoryName }) => {
  const navigate = useNavigate();

  if (articles.length === 0) {
    return null;
  }

  return (
    <div className="uk-section uk-section-muted" style={{ 
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      padding: '60px 0'
    }}>
      <div className="uk-container uk-container-large">
        {/* Header de la sección de noticias */}
        <div className="uk-text-center uk-margin-large-bottom">
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            background: 'linear-gradient(135deg, #20D3C7, #17BCBA)',
            padding: '12px 24px',
            borderRadius: '50px',
            marginBottom: '20px',
            boxShadow: '0 4px 15px rgba(32, 211, 199, 0.3)'
          }}>
            <i className="fas fa-newspaper" style={{ 
              color: 'white', 
              fontSize: '20px',
              marginRight: '10px'
            }}></i>
            <span style={{ 
              color: 'white', 
              fontSize: '14px',
              fontWeight: '600',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              Noticias Argentinas
            </span>
          </div>
          <h2 style={{ 
            fontSize: '32px',
            fontWeight: '700',
            color: '#333',
            marginBottom: '15px'
          }}>
            Últimas noticias del sector
          </h2>
          <p style={{ 
            fontSize: '16px',
            color: '#666',
            maxWidth: '600px',
            margin: '0 auto',
            lineHeight: '1.6'
          }}>
            Mantente informado sobre las últimas tendencias, innovaciones y novedades del sector de {categoryName.toLowerCase()} en Argentina
          </p>
        </div>

        {/* Grid de noticias */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px',
          width: '100%'
        }}>
          {articles.map((article) => (
            <NewsCard key={article.id} article={article} />
          ))}
        </div>

        {/* Botón para ver más noticias */}
        <div className="uk-text-center uk-margin-large-top">
          <button className="uk-button uk-button-secondary"
                  style={{ 
                    border: '2px solid #20D3C7',
                    color: '#20D3C7',
                    borderRadius: '50px',
                    padding: '15px 30px',
                    fontSize: '16px',
                    fontWeight: '600',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    transition: 'all 0.3s ease',
                    background: 'transparent',
                    cursor: 'pointer'
                  }}
                  onClick={() => navigate('/noticias')}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.background = '#20D3C7';
                    e.currentTarget.style.color = 'white';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.background = 'transparent';
                    e.currentTarget.style.color = '#20D3C7';
                    e.currentTarget.style.transform = 'translateY(0)';
                  }}>
            <i className="fas fa-newspaper uk-margin-small-right"></i>
            Ver todas las noticias
          </button>
        </div>
      </div>
    </div>
  );
};

export default NewsSection;
